<script>

    export let match;   

</script>
<div class='list-group list-group-flush'>
    <div class='list-group-item'>

        {#if match.teamA == null}

            <div class='row'>
                <div class='col-2'>
                    
                </div>
                <div class='col-8 text-center'>
                    <h4 class='m-0 text-secondary'>
                        <span class='fas fa-info-circle'></span> EMPTY
                    </h4>
                </div>
                <div class='col-2 text-end'>
                    
                   
                </div>
            </div>                

        {:else}

            <div class='row'>
                <div class='col-2'>

                    {#if match.teamA.logo}

                        <img src={match.teamA.logo} class='img-responsive img-thumbnail' alt='Team Logo'/>

                    {/if}

                </div>
                <div class='col-8 text-center'>
                    <div class=''>                        
                        <h4 class='m-0 mb-1 text-primary text-truncate'>

                            { match.teamA.name }
        
                        </h4>                                                
                        
                    </div>
                </div>
                <div class='col-2 text-end'>                    
                   
                </div>
            </div>            

        {/if}

    </div>
    <div class='list-group-item'>
        <div class='text-center'>
            <h5 class='m-0'>
                VS
            </h5>
        </div>
    </div>
    <div class='list-group-item'>
        
        {#if match.teamB == null}

            <div class='row'>
                <div class='col-2'>
                    
                </div>
                <div class='col-8 text-center'>
                    <h4 class='m-0 text-secondary'>
                        <span class='fas fa-info-circle'></span> EMPTY
                    </h4>
                </div>
                <div class='col-2 text-end'>
                                       

                </div>
            </div> 

            {:else}

            <div class='row'>
                <div class='col-2'>

                    {#if match.teamB.logo}

                        <img src={match.teamB.logo} class='img-responsive img-thumbnail' alt='Team Logo'/>

                    {/if}

                </div>
                <div class='col-8 text-center'>
                    <h4 class='m-0 mb-1 text-primary text-truncate'>

                        { match.teamB.name }
    
                    </h4>                   

                </div>
                <div class='col-2 text-end'>
                    
                </div>
            </div>

        {/if}

    </div>
</div>
<style>
    .team_logo {
        max-width: 45px;
        max-height: 45px;
    }
</style>